import React, { useState, useEffect, useContext, useMemo } from "react";
import { pdfHeader, pdfTableStyles, pdfFooter, pdfDocumentoTabla } from "../../../../pdfUtils";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import moment from "moment";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoAjustesInventario() {
  const { user } = useContext(AuthContext);
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_ARTICULOS_AJUSTES_INV = process.env.REACT_APP_URL_ARTICULOS_AJUSTES_INV;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_AJUSTES_INVENTARIO = process.env.REACT_APP_URL_AJUSTES_INVENTARIO;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;

  const [areas, setAreas] = useState([]);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(moment().subtract(3, "months").format("YYYY-MM-DD"));
  const [selectedFechaFin, setSelectedFechaFin] = useState(moment().format("YYYY-MM-DD"));
  const [selectedArea, setselectedArea] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_AJUSTES_INVENTARIO}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMuestras = response.data;
        // Array para pagination
        let arrayTabla = allMuestras
          .sort((a, b) => (a.idMuestrasEntrada < b.idMuestrasEntrada ? 1 : -1))
          .map((a) => {
            if((user.areas == AREAS_GENERAL)){
            return {
              _id: a._id,
              numero: a.idAjustesInventario,
              fecha: a.fecha,
              observaciones: a.observaciones,
              total: a.total,
              area: a.areas[0].name,
              idArea: a.areas[0]._id,
              autorizado:a.autorizado,
              activo: a.is_active || "Si"
            }} else if(user.areas == a.areas[0]._id){
              return {
                _id: a._id,
                numero: a.idAjustesInventario,
                fecha: a.fecha,
                observaciones: a.observaciones,
                total: a.total,
                area: a.areas[0].name,
                idArea: a.areas[0]._id,
                autorizado:a.autorizado,
              activo: a.is_active || "Si"
              }
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [user, selectedFechaInicio, selectedFechaFin]);

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedArea == 0 || selectedArea == a.idArea)
      ) {
        return [
          a.numero,
          a.fecha,
          a.observaciones,
          a.area,
          new Intl.NumberFormat("en-US").format(a.total),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    const inicioPDF = pdfHeader(doc, `Listado Ajustes de Inventario`, `${selectedFechaInicio} - ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      startY: inicioPDF,
      head: [
        ["Numero", "Fecha","Observaciones", "Almacen", "Cantidad"],
      ],
      body: dataPDFLimpia,
 
          
          
      
    });
    pdfFooter(doc);
    doc.save(`AjustesInventario.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedArea == 0 || selectedArea == a.idArea) 
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Observaciones: a.observaciones,
          Almacen: a.area,
          Cantidad: a.total,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoAjustesInventario";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoAjustesInventario",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Observaciones",
          "Almacen",
          "Cantidad",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Observaciones",
          "Almacen",
          "Cantidad",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedArea == 0 || selectedArea == a.idArea)
      ) {
        return [
          a.numero,
          a.fecha,
          a.observaciones,
          a.area,
          new Intl.NumberFormat("en-US").format(a.total),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    const inicioPDF = pdfHeader(doc, `Listado Ajustes de Inventario`, `${selectedFechaInicio} - ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      startY: inicioPDF,
      head: [
        ["Numero", "Fecha", "Observaciones", "Almacen", "Cantidad"],
      ],
      body: dataPDFLimpia,
 
          
          
      
    });
    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ajustes Inventario",
          email: mailTo,
          fileName: "ListadoAjustesInventario.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ajustes Inventario.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Listo", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Algo salio mal",
          text: "No se pudo completar",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }


  async function PDFOC(
    numero,
    fecha,
    observaciones,
    area,
    total,
    idPDFOC
  ) {
    await axios
      .get(`${URL_ARTICULOS_AJUSTES_INV}Ajuste/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        let arrayTabla = allArticulos
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].codigo + " " + a.articulos[0].nombre,
              cantidad: a.cantidad,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        const data = dataFinal.map((a) => {
          return [
            a.articulos,
            new Intl.NumberFormat("en-US").format(a.cantidad),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF({ compressPdf: true });
        pdfDocumentoTabla(doc, {
          titulo: "Ajuste de inventario",
          folio: numero,
          fecha,
          datos: [{ titulo: "Datos", lineas: [`Almacen ${area}`] }],
          head: ["Vino", "Cantidad"],
          body: dataPDFLimpia,
          totales: [["Total botellas", new Intl.NumberFormat("en-US").format(total)]],
          observaciones,
        });
        pdfFooter(doc);
        doc.save(`Ajuste-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Cantidad", field: "total", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.numero.toString().includes(search) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.total.toString().includes(search)
      );
    }
    if (selectedArea) {
      computedComments = computedComments.filter((e) =>
        e.idArea.includes(selectedArea)
      );
    }
    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
 

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedArea,
  ]);

  // Cancela un ajuste. El back solo lo permite si NO esta autorizado
  // (un ajuste sin autorizar nunca movio inventario, no hay que revertir nada).
  function cancelarAjuste(id, numero) {
    Swal.fire({
      title: "¿Estas seguro?",
      text: `Se cancelara el ajuste ${numero}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_AJUSTES_INVENTARIO}Cancelar/${id}`,
            {},
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Cancelar Ajuste Inventario",
                detalle: `Ajuste ${numero}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Listo", "Cancelado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Algo salio mal",
              text: "No se pudo completar",
              footer: `${
                error?.response?.data?.message || "Error al cancelar"
              }`,
            });
            console.log(error);
          });
      }
    });
  }

  function autorizar(id) {
    const URL_AUTORIZADO = `${URL_AJUSTES_INVENTARIO}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_AJUSTES_INV}/autorizado/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  ajustesInventario: id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
          }).then(()=>{
            Swal.fire("Listo", "Creado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Algo salio mal",
              text: "No se pudo completar",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Algo salio mal",
              text: "No se pudo completar",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }
 
  return (
    <>
      <Header />
      <br />
      <br />
      {user.ajustesInventario ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.ajustesInventario ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/AjustesInventarioCreate"
                >
                  Nuevo Ajuste
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Ajuste
                </Button>
              )}
              {/* <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button> */}
            </Col>
            <Col sm={4}>
              {user.exportar ? (
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
              ) : null}
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Entrada de Muestras</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ajustes de Inventario</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>


            </tr>
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr
                      style={
                        a.activo == "No"
                          ? { backgroundColor: "#ed8c8c" }
                          : undefined
                      }
                    >
                      <td>
                        {a.numero}
                        {a.activo == "No" ? " (CANCELADO)" : ""}
                      </td>
                      <td>{a.fecha}</td>
                      <td>{a.observaciones}</td>
                      <td>{a.area}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total)}</td>
                      <td>
                      {user.ajustesInventario ? (
                          <div>
                             <Button
                               disabled={!user.imprimir}
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => PDFOC( 
                                a.numero,
                                a.fecha,
                                a.observaciones,
                                a.area,
                                a.total,
                                a._id 
                                )}
                            ><i class="far fa-file-pdf"></i>
                            </Button>
                            {a.autorizado == "No" && a.activo == "Si" && user.autorizarAjustesInventario ? (
                              <Button
                              color="primary"
                              id="Baja"
                              onClick={(e) =>
                                autorizar(a._id)
                              }
                              size="sm"
                            >
                              <i class="fas fa-thumbs-up"></i>
                            </Button>
                            ):(
                              undefined
                            )}
                            {/* Cancelar: solo si NO esta autorizado (validado) y sigue activo */}
                            {a.autorizado == "No" && a.activo == "Si" && user.autorizarAjustesInventario ? (
                              <Button
                                color="danger"
                                id="Cancelar"
                                onClick={(e) => cancelarAjuste(a._id, a.numero)}
                                size="sm"
                              >
                                <i class="fas fa-ban"></i>
                              </Button>
                            ) : undefined}
                            </div>
                        ) : undefined}
                        </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      
      {loader}
    </>
  );
}

export default ListadoAjustesInventario;
